import React from 'react'

const IconArrowForword = ({ fill = '#686867' }) => {
  return (
    <svg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.16406 4.99955L0.226562 1.06204L1.00052 0.288086L5.71198 4.99955L1.00052 9.711L0.226562 8.93705L4.16406 4.99955Z'
        fill={fill}
      />
    </svg>
  )
}

export default IconArrowForword
